import React from 'react';
import Login from '../components/LoginPage/Login';
import '../css/LoginPage/Login.css';

function LoginPage() {
    return (
        <div className = 'login'>
            <Login />
        </div>
    )
}



export default LoginPage;